import type { SidebarItem } from '@/types/nav';
import { ROUTES } from '@/routes';
import {
  GridFill,
  GridOutline,
  PieChartFill,
  PieChartOutline,
  FileTextFill,
  FileTextOutline,
  ShoppingBagOutline,
  MenuFill,
  MenuOutline,
  SmallShopFill,
  SmallShopOutline,
} from '@/assets/icons/Sidebar';
import { LinkOutIcon } from '@/assets/icons/Sidebar';

export const SIDEBAR_ITEMS: SidebarItem[] = [
  {
    title: '대시보드',
    url: ROUTES.dashboard,
    iconFill: GridFill,
    iconOutline: GridOutline,
  },
  {
    title: '주문',
    url: ROUTES.orders,
    iconFill: FileTextFill,
    iconOutline: ShoppingBagOutline,
    subItems: [
      { title: '주문 내역', url: `${ROUTES.orderDetails}?orderTab=new-order` },
      { title: '리뷰 관리', url: `${ROUTES.reviews}?ctab=whole` },
      { title: '문의 관리', url: `${ROUTES.inquiries}?ctab=not-yet` },
    ],
  },
  {
    title: '통계',
    url: ROUTES.statistics,
    iconFill: PieChartFill,
    iconOutline: PieChartOutline,
  },
  {
    title: '상품 순위 모니터링',
    url: ROUTES.monitoring,
    iconFill: FileTextFill,
    iconOutline: FileTextOutline,
  },
  {
    title: '내 마켓 관리',
    url: ROUTES.market,
    iconFill: SmallShopFill,
    iconOutline: SmallShopOutline,
  },

  {
    title: '더보기',
    url: ROUTES.more,
    iconFill: MenuFill,
    iconOutline: MenuOutline,
    subItems: [
      { title: '멤버십', url: `${ROUTES.more}?ctab=membership` },
      { title: 'FAQ', url: `${ROUTES.more}?ctab=faq` },
      { title: '1:1 문의', url: `${ROUTES.more}?ctab=support` },

      {
        title: (
          <div className="flex items-center gap-1 text-gr-600 Body3S15">
            공지사항 <LinkOutIcon className="h-4 w-4 " />
          </div>
        ),
        url: 'https://www.cplat.io/notice',
      },
    ],
  },
];
